module.exports = "/assets/936e8058fd016eeb0fb3abb92c2fb8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VF.png
// module id = 3043
// module chunks = 0